import {
  defineStore,
  acceptHMRUpdate
} from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => {
    return {
      isCollapse: false,
      showLogo: true,
    }
  },
  getters: {

  },
  actions: {
    setIsCollapse(isCollapse) {
      this.isCollapse = isCollapse
    },
    setShowLogo(showLogo) {
      this.showLogo = showLogo
    }
  },
})

if (
  import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAppStore,
    import.meta.hot))
}
